import { render } from "./ForgotPasswordOTP.vue?vue&type=template&id=8a8e0906&scoped=true"
import script from "./ForgotPasswordOTP.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordOTP.vue?vue&type=script&lang=js"

import "./ForgotPasswordOTP.vue?vue&type=style&index=0&id=8a8e0906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8e0906"]])

export default __exports__